
import descCard from '../cards/descCard.vue'
export default {
  components: { descCard },
    name: "basiccardlistingDefault",
    props:
    {
        content: Object
    }
}
